import './index.scss'
$(".service-nav div").eq(0).addClass("active");
$(".service-list .content").eq(0).addClass("active");
$(".service-nav div").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".service-list .content").eq(index).addClass("active").siblings().removeClass("active");
})